import { useTranslations } from 'next-intl'
import { AuthTextLink } from '@/app/(auth)/components/auth-text-link'

interface AuthLegalFooterProps {
  /**
   * The consent action. omnyqra: a fixed variant instead of an English gerund, so
   * each language translates the whole sentence (Omnyqra/sim#43), see FORK.md
   */
  action: 'signIn' | 'signUp'
}

/**
 * The "By {action}, you agree to our Terms / Privacy" fine print shared by the
 * login and signup pages. Restyled to muted light tokens with the legal links
 * routed through {@link AuthTextLink}, so the consent copy has one source.
 */
export function AuthLegalFooter({ action }: AuthLegalFooterProps) {
  const t = useTranslations('auth.common')
  return (
    <p className='text-center text-[var(--text-muted)] text-caption leading-relaxed'>
      {t.rich(action === 'signIn' ? 'legalSignIn' : 'legalSignUp', {
        terms: (chunks) => (
          <AuthTextLink href='/terms' external>
            {chunks}
          </AuthTextLink>
        ),
        privacy: (chunks) => (
          <AuthTextLink href='/privacy' external>
            {chunks}
          </AuthTextLink>
        ),
      })}
    </p>
  )
}
